module.exports = __webpack_public_path__ + "static/media/WorkTime.f95f84f6.svg";